import { render, staticRenderFns } from "./PrintDetail.vue?vue&type=template&id=4ff1ec38&scoped=true&"
import script from "./PrintDetail.vue?vue&type=script&lang=js&"
export * from "./PrintDetail.vue?vue&type=script&lang=js&"
import style0 from "./PrintDetail.vue?vue&type=style&index=0&id=4ff1ec38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff1ec38",
  null
  
)

export default component.exports